import { Component, OnInit, ViewChild, Injectable, Inject } from '@angular/core';
import { AlphaSearchListVM, RecDateSearchRowVM, RecDocVM, GetRecDateSearchQuery, GetRecDateSearchReportQuery, SearchFilter, GetAlphaSearchQuery } from '../../../shared/viewmodels/ISearchService';
import { DxDataGridComponent } from 'devextreme-angular';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { RecSearchService } from '../../rec-search-service';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { ReportViewerService } from '../../../shared/services/report-viewer.service';
import { Router, ActivatedRoute } from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
//import { listener } from '@angular/core/src/render3';
import * as NameActions from './../../../store/actions/name.action';
import * as CompoundNameActions from './../../../store/actions/compoundname.action';
import * as RoleActions from './../../../store/actions/role.action';
import * as ContainsActions from './../../../store/actions/contains.action';
import * as DateRangeActions from './../../../store/actions/daterange.action';
import * as CityActions from './../../../store/actions/citytown.action';
import * as DocTypeActions from './../../../store/actions/doctype.action';
import { CompoundNameComponent } from '../../../shared/components/compound-name/compound-name.component';
import { CompoundNameComponent2 } from '../../../shared/components/compound-name2/compound-name2.component'
//import { CompoundDoubleNameComponent } from '../../../shared/components/compound-double-name/compound-double-name.component';
import { DaterangeComponent } from '../../../shared/components/daterange/daterange.component';
import { RoleComponent } from '../../../shared/components/role/role.component';
import { ContainsComponent } from '../../../shared/components/contains/contains.component';
import { RoleComponent2 } from '../../../shared/components/role2/role2.component'
import { CityTownEXComponent } from '../../../shared/components/city-town-ex/city-town-ex.component';
import { DoctypeexComponent } from '../../../shared/components/doctypeex/doctypeex.component';

@Component({
  selector: 'app-rec-alpha-search-grid',
  templateUrl: './rec-alpha-search-grid.component.html',
  providers: [RecSearchService, ReportViewerService],
  styleUrls: ['./rec-alpha-search-grid.component.css']
})
export class RecAlphaSearchGridComponent implements OnInit {

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild(CompoundNameComponent, { static: false }) cName: CompoundNameComponent;


  public errorMsg: string;
  public searchresults: any = {};//RecDateSearchRowVM[];
  public recdoc: RecDocVM;
  public re: string;
  applyFilterTypes: any;
  currentFilter: any;
  showFilterRow: boolean;
  console = console;
  public roleId: number;
  towns: string[] = [];
  doctypes: string[] = [];
  public remoteOps: any = {};
  public infoFromServer: string;
  userInput: any;

  focusedRowKey: number;
  recordCount: number = 0;
  appurl: string;

 // constructor(private service: RecSearchService, private reportService: ReportViewerService, private router: Router, private store: Store<AppState>) {
  constructor(private service: RecSearchService, private router: Router, private store: Store<AppState>, @Inject('BASE_URL') baseUrl: string ) {
    this.remoteOps = {
      paging: false,
      filtering: false,
      sorting: false,
      grouping: false,
      summary: false
    };

    this.appurl = baseUrl;

  

    this.store.select(getRegSearchState).pipe(take(1)).subscribe(data => {
      this.userInput = data;
      this.roleId = this.userInput.role.role[1].roleID;
      //for (let city of this.userInput.city[0].citytowns) {
      //  if (city.isChecked)
      //    this.towns.push(city.townAbbrev);
      //}

      //for (let doctype of this.userInput.doct[0].doctypes) {
      //  if (doctype.isChecked)
      //    this.doctypes.push(doctype.docCode);
      //}

      console.log('alpha search grid ' + this.userInput.name.name[1].lastcorpName + ' ' + this.userInput.name.name[1].fName + ' ' + this.roleId);
      //this.getAlphaResults(this.userInput.name[0].lastcorpName, this.userInput.name[0].fName);

    });

    this.showFilterRow = true;
    this.applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }];

    this.currentFilter = this.applyFilterTypes[0].key;

  }


//  mouseover(event) {
//    //console.log(`onmouseover fired: ${JSON.stringify(event)}`);
//    //console.log(`target: ${event.target.id}`);
//    //this.infoFromServer = event.target.id;

//    var docIDstring = (event.target.id as string).split('_')[1];
//    this.console.log(`Our docId: ${docIDstring}`);
//    var docID = Number(docIDstring);
//    this.service.getRecDoc(docID).subscribe(data => {
//      this.infoFromServer = `
//<div style="text-align: left;">
//      Grantors: <br />

//`;
//      data.docTors.forEach(tor => {
//        this.infoFromServer +=  "&nbsp;&nbsp;" + tor.lastCorpName + " " + tor.fName + "<br />";
//      });

//      this.infoFromServer += "Grantees: <br />";
//      data.docTees.forEach(tee => {
//        this.infoFromServer += "&nbsp;&nbsp;" + tee.lastCorpName + " " + tee.fName + "<br />"
//      });
//      this.infoFromServer += "</div>"
//    });
//  }


  ngOnInit() {
    //this.lname = this.router.snapshot.paramMap.get('lname');
    //this.fname = this.router.snapshot.paramMap.get('fname');
    //console.log('alpha search grid ' + this.userInput.name[0].lastcorpName + ' ' + this.userInput.name[0].fName + ' ' + this.roleId) ;
    console.log('ngOnInit - alpha search ');
    this.searchresults = new CustomStore({
      key: "",
      load: (loadOptions: any) => {
        let query = new GetAlphaSearchQuery({
          last_name: this.userInput.name.name[1].lastcorpName,
          first_name: this.userInput.name.name[1].fName,
          roleId: this.userInput.role.role[1].roleID
        });
        //return this.service.getAlphaSearchResults(this.lname, this.fname).toPromise().then(data => {
        return this.service.getAlphaSearchResults(query).toPromise().then(data => {
          this.recordCount = data.alphaSearchRows.length;
          return {
            data: data.alphaSearchRows,
            totalCount: data.alphaSearchRows.length
          };
        //}).catch(error => { this.errorMsg = error });
        }).catch(error => { throw  'Data Loading Error' });
      }
    });
    
    console.log('search result ' + this.recordCount);
  }

  //getAlphaResults(pLName, pFName) {
    //let search = new GetRecDateSearchQuery({
    //  fromDate: fromdate,
    //  toDate: todate,
    //  towns: towns,
    //  doctypes: types
    //});

    //this.service.getAlphaSearchList(pLName, pFName).subscribe(data => {
    //  this.searchresults = data;
    //  this.recordCount = this.searchresults.length
    //},

    //  error => this.errorMsg = error

    //);


    //this.service.getDateSearchResults(fromdate, todate, towns, types).subscribe(data => {
    //  this.recsresults = data;
    //  this.recordCount = this.recsresults.length
    //},

    //  error => this.errorMsg = error

    //);
  //}


  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }

  onInitialized(e) {

  }

  //Open image in another tab'
  imgClicked(event) {
    if (!this.dataGrid.instance.isRowSelected(event.row.key)) {
      this.dataGrid.instance.selectRows(event.row.key, false);
    }
    // this.nav.visible = false;


  }

  onExpanding(e) {
    this.focusedRowKey = e.component.option("focusedRowIndex");
    this.focusedRowKey = e.key.index;
    e.component.collapseAll(-1);
  }

  assignTypes(filters: SearchFilter[]) {
    if (filters) {
      filters.forEach(fl => {
        if (fl.filterType == 'join') {
          this.assignTypes(fl.filters);
        } else {
          for (var prop in this.searchresults[0]) {
            if (prop == fl.fieldName) {
              fl.fieldType = typeof this.searchresults[0][prop];
            }
          }
        }

      });
    }
  }


  search(last_name, first_name) {

    console.log('alpha grid ' + last_name + ' ' + first_name + ' ' + this.roleId);
    //console.log('alpha grid ' + e.row.values[1]);

    first_name = first_name.trim();

    //this.delRecFromStore(0);

    //this.addRecToStore(
    //  first_name, //first name
    //  last_name, //last name
    //  this.roleId, //this.roleChild.utilityobj.roleID,
    //  0, //this.containsChild.utilityobj.contains,
    //  '', //this.compoundNameChild2.utilityobj.fName2,
    //  '', //this.compoundNameChild2.utilityobj.lastcorpName2,
    //  0, //this.roleChild2.utilityobj.roleID2,
    //  new Date('1/1/1962'), //this.dateRangeChild.utilityobj.fromDate,
    //  new Date(), //this.dateRangeChild.utilityobj.toDate,
    //  '', //this.cityTownChild.utilityobj.citytowns,
    //  '');  //this.docTypeChild.utilityobj.doctypes);

    //const params: queryParams = { lname: last_name, fname: first_name }
    const url = this.router.createUrlTree(['rec-name-result-pg', { lname: last_name, fname: first_name, role: this.roleId }])
    //console.log(this.appurl);
    //console.log(this.appurl + url.toString());
    //console.log(url.toString());

    //this.appurl = this.appurl.substring(0, this.appurl.length - 2) + url.toString();
    //console.log(this.appurl)

    const tUrl = this.appurl + url.toString().substring(1);
    //console.log(tUrl);

    window.open(tUrl, '_blank');
    
    //console.log(url);
    //window.open('/rec-name-result-pg', '_blank');
    //this.router.navigate(['/rec-name-result-pg']);

  }

  search2(e) {

    console.log('alpha grid2 ' + e.row.values[0]);
    console.log('alpha grid2 ' + e.row.values[1]);

    this.recordCount = 2;

    console.log('alpha grid2 ' + this.recordCount);

    //this.delRecFromStore(0);

    //this.addRecToStore(
    //  e.row.values[1], //first name
    //  e.row.values[0], //last name
    //  0, //this.roleChild.utilityobj.roleID,
    //  0, //this.containsChild.utilityobj.contains,
    //  '', //this.compoundNameChild2.utilityobj.fName2,
    //  '', //this.compoundNameChild2.utilityobj.lastcorpName2,
    //  0, //this.roleChild2.utilityobj.roleID2,
    //  new Date('1/1/1962'), //this.dateRangeChild.utilityobj.fromDate,
    //  new Date('12/31/2021'), //this.dateRangeChild.utilityobj.toDate,
    //  '', //this.cityTownChild.utilityobj.citytowns,
    //  '');  //this.docTypeChild.utilityobj.doctypes);


    //    const target = url + '/' + this.compoundNameChild.utilityobj.lastcorpName + '/' + this.compoundNameChild.utilityobj.fName;
    //    window.open(url, "_blank")
    console.log('calling router');
   // this.router.navigate(['/rec-name-result-pg']);

  }


  getRecCount (){
    this.recordCount = 9;
  }


  addRecToStore(fname, lname, role, Contains, fname2, lname2, role2, fromdate, todate, citytowns, doctypes) {

    console.log('add rec ' + lname + ' ' + fname);

    this.store.dispatch(new CompoundNameActions.AddName({
      fName: fname,
      lastcorpName: lname
    }));

    this.store.dispatch(new RoleActions.AddRole({
      roleID: role
    }));

    console.log('Contains - ' + Contains);

    this.store.dispatch(new ContainsActions.AddContains({
      contains: Contains
    }));

    this.store.dispatch(new DateRangeActions.AddDate({
      fromDate: fromdate,
      toDate: todate
    }));

    this.store.dispatch(new CityActions.AddCity({
      citytowns: citytowns
    }));

    this.store.dispatch(new DocTypeActions.AddDoct({
      doctypes: doctypes
    }));
  }

  delRecFromStore(index) {
    console.log('del rec');
    this.store.dispatch(new NameActions.RemoveName(index));
    this.store.dispatch(new RoleActions.RemoveRole(index));
    this.store.dispatch(new ContainsActions.RemoveContains(index));
    this.store.dispatch(new DateRangeActions.RemoveDate(index));
    this.store.dispatch(new CityActions.RemoveCity(index));
    this.store.dispatch(new DocTypeActions.RemoveDoct(index));
  }


}
